import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en";
import es from "./locales/es";
import pt from "./locales/pt";
import ru from "./locales/ru";
import uk from "./locales/uk";
import hi from "./locales/hi";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "ru", label: "Русский" },
  { code: "uk", label: "Українська" },
  { code: "hi", label: "हिन्दी" },
];

export const NON_EN_CODES = ["es", "pt", "ru", "uk", "hi"];
export const ALL_LANG_CODES = ["en", "es", "pt", "ru", "uk", "hi"];

const STORAGE_KEY = "i18n-lang";

function getInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && ALL_LANG_CODES.includes(stored)) return stored;
  } catch { /* SSR / restricted storage */ }
  return "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    pt: { translation: pt },
    ru: { translation: ru },
    uk: { translation: uk },
    hi: { translation: hi },
  },
  lng: getInitialLang(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
